import React from 'react';
import PropTypes from 'prop-types';
import fullstory from '../../../utils/constants/fullstory';

const renderSearchBox = ({ className, input, placeholder, type, label, meta }) => {
  const { touched, error } = meta;

  return (
    <React.Fragment>
      <div id="renderSearchBox" style={{ display: 'flex' }}>
        {label && <label style={{ display: 'block' }}>{label}</label>}
        <div className="input-group shadow" style={{ zIndex: 0 }}>
          <input
            {...input}
            type={type}
            className={`form-control ${className} ${fullstory.classNames.searchbar}`}
            style={{ height: '100%' }}
            placeholder={placeholder}
            autoComplete="off"
          />

          <span className="input-group-append">
            <button
              className="btn btn-outline-secondary"
              type="submit"
              style={{ border: '1px solid #ced4da', padding: '18px 25px' }}
            >
              <i className="fal fa-search" />
            </button>
          </span>

        </div>

      </div>
      {
        touched && error && (
          <h6 className="text-danger small text-justify" style={{ marginTop: '5px', marginBottom: '5px' }}>
            {error}
          </h6>
        )
      }
    </React.Fragment>
  );
};

renderSearchBox.propTypes = {
  className: PropTypes.string,
  input: PropTypes.any.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.any,
  label: PropTypes.string,
};

renderSearchBox.defaultProps = {
  type: 'text',
  placeholder: '',
};

export default renderSearchBox;



// WEBPACK FOOTER //
// ./src/components/ui/forms/renderSearchBox.js